import * as React from 'react';
import { Link } from '../link/link';
import { IPromoLink } from '../../../shared/types/promo';
const s = require('./promo_image.css');

interface IProps {
  imageUrl: string;
  extraLinks?: IPromoLink[];
}

export const PromoImage = (props: IProps) => (
  <div
    className={s['c-promo-block-image-content']}
    style={{ backgroundImage: `url(${require('./img/' + props.imageUrl)})` }}
  >
    {props.extraLinks && (
      <div className={s['c-promo-catalog-list']}>
        {props.extraLinks.map((link: IPromoLink, i: number) => (
          <Link key={i} href={link.url} className={`${s['c-promo-catalog-list-item']}`} title={link.h1}>
            {link.title}
          </Link>
        ))}
      </div>
    )}
  </div>
);
